import {Component, EventEmitter, Output} from '@angular/core';
import {ButtonModule, IconComponent} from '@adnova/jf-ng-components';


@Component({
  selector: 'zlng-beleglos',
  templateUrl: './beleglos.component.html',
  styleUrls: ['./beleglos.component.scss'],
  standalone: true,
  imports: [
    IconComponent,
    ButtonModule,
  ]
})
export class BeleglosComponent {

  @Output()
  openBelegChooser = new EventEmitter<void>();

  constructor() {
  }

  doOpenBelegChooser(): void {
    this.openBelegChooser.emit();
  }
}
